export default __webpack_public_path__ + "static/media/ai-image-generator-screenshot-05.e4510990.png";